import * as Yup from 'yup';

export default Yup.object().shape({
  name: Yup.string().min(2, 'O nome deve ter no mínimo 2 caracteres').required('Obrigatório'),
  email: Yup.string().matches(/^\s*(([^<>()[\]\\.,;:\s@]+(\.[^<>()[\]\\.,;:\s@]+)*)|(.+))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))\s*$/, "Email inválido").min(2).required('Obrigatório'),
  cellphone: Yup.string().transform(value => value.replace(/[^\d]/g, '')).min(11, "Celular Inválido").required('Obrigatório'),
  checkbox: Yup.boolean().oneOf([true], 'Você deve Aceitar os Termos antes de Continuar'),
})